
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useIncubadoraXID } from "../../../hooks";
import { useCiudadesStore } from "../../../store";
import { DisenioPaginas } from "../../layout";
import { CargandoMedio, FormCreateUpdateIncubadora } from "../../components";






export const ActualizarEncubadora = () => {


    const { id } = useParams();
    const { incubadoraXIDQuery } = useIncubadoraXID(`${id}`);
    const incubadora = incubadoraXIDQuery?.data
    const { startListadoCiudades } = useCiudadesStore();
    



    useEffect(() => {
        if (incubadora?.departamento) {
            startListadoCiudades(incubadora.departamento);
        }
    }, [incubadora?.departamento]);




    const initialState = (incubadora) ? {
        nombre: incubadora.nombre || "",
        telefono: incubadora.telefono || "",
        nit: incubadora.nit || "",
        direccion: incubadora.direccion || "",
        email: incubadora.email || "",
        ciudad: incubadora.ciudad || "",
        departamento: incubadora.departamento || "",
        id: incubadora.id || "",
    } : {};


    

    return (

        <DisenioPaginas titulo="Actualizar Incubadora" url={1} add={false} subtitulo="Información de la incubadora">
            {(incubadoraXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Incubadora..." />
            :   <FormCreateUpdateIncubadora initialState={initialState} />
            }
        </DisenioPaginas>

    )
}
